// src/theme/ThemeProvider.jsx
import React, { useState, useMemo } from "react";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { responsiveFontSizes } from "@mui/material/styles";
import ThemeContext, { createBaseTheme } from "./ThemeContext";

export const ThemeContextProvider = ({ children }) => {
  const [mode, setMode] = useState("light"); // Start with light mode

  // Add media query to detect mobile devices
  const isMobile = useMediaQuery("(max-width:600px)");

  const toggleTheme = () => {
    setMode((prevMode) => (prevMode === "dark" ? "light" : "dark"));
  };

  // Create responsive theme
  const theme = useMemo(() => {
    // Create theme based on mode
    let theme = createBaseTheme(mode);

    // Apply responsive font sizing *BEFORE* creating component overrides
    theme = responsiveFontSizes(theme, {
      breakpoints: ["xs", "sm", "md", "lg", "xl"],
      factor: 2, // Larger factor makes the difference between sizes more dramatic
    });

    console.log("Responsive Theme:", theme); // Debugging: Log the responsive theme
    return theme;
  }, [mode]);

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, isMobile }}>
      <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>
    </ThemeContext.Provider>
  );
};
